import { render, staticRenderFns } from "./ajUpload.vue?vue&type=template&id=96dd9036&scoped=true"
import script from "./ajUpload.vue?vue&type=script&lang=js"
export * from "./ajUpload.vue?vue&type=script&lang=js"
import style0 from "./ajUpload.vue?vue&type=style&index=0&id=96dd9036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96dd9036",
  null
  
)

export default component.exports